export const HOVER_PREVIEW_OPEN_DELAY_MS = 500;
